(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function qsa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- cart count ---------- */
  function setCount(n) {
    qsa('[data-sk-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !(n > 0); });
  }
  function refreshCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); })
      .catch(function () {});
  }
  var nativeFetch = window.fetch;
  if (nativeFetch && !window.__skFetch) {
    window.__skFetch = true;
    window.fetch = function () {
      var a = arguments, u = '';
      try { u = typeof a[0] === 'string' ? a[0] : (a[0] && a[0].url) || ''; } catch (e) {}
      var p = nativeFetch.apply(this, a);
      if (/\/cart\/(add|change|update|clear)/.test(u)) {
        p.then(function () { setTimeout(refreshCount, 250); }).catch(function () {});
      }
      return p;
    };
  }

  /* ---------- add to cart (product cards) ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[data-sk-atc]')) return;
    e.preventDefault();
    var btn = f.querySelector('button[type="submit"]');
    var label = btn ? (btn.getAttribute('data-label') || btn.textContent) : '';
    function restore(ms) {
      setTimeout(function () {
        if (btn) { btn.textContent = label; btn.disabled = false; btn.classList.remove('is-loading'); }
      }, ms);
    }
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f), credentials: 'same-origin' })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error((res.j && (res.j.description || res.j.message)) || 'error'); }
        if (btn) { btn.textContent = btn.getAttribute('data-added') || 'Added'; }
        refreshCount();
        document.documentElement.dispatchEvent(new CustomEvent('sk:cart-add', { bubbles: true, detail: res.j }));
        if (f.getAttribute('data-redirect') === 'cart') {
          window.location.href = f.getAttribute('data-cart-url') || (root + 'cart');
          return;
        }
        restore(1800);
      })
      .catch(function () {
        if (btn) { btn.textContent = btn.getAttribute('data-error') || 'Try again'; }
        restore(2200);
      });
  });

  /* ---------- sliders ---------- */
  function initSlider(box) {
    if (box.__sk) return;
    var track = box.querySelector('[data-sk-track]');
    if (!track) return;
    box.__sk = true;
    var prev = box.querySelector('[data-sk-prev]');
    var next = box.querySelector('[data-sk-next]');
    var dots = qsa('[data-sk-dot]', box);
    var loop = box.getAttribute('data-loop') === 'true';
    var auto = parseInt(box.getAttribute('data-autoplay') || '0', 10);
    var timer = null;

    function step() {
      var first = track.children[0];
      if (!first) return track.clientWidth;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function maxScroll() { return track.scrollWidth - track.clientWidth - 2; }
    function index() { var s = step(); return s ? Math.round(track.scrollLeft / s) : 0; }
    function update() {
      var i = index();
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      if (!loop) {
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= maxScroll();
      }
    }
    function go(dir) {
      if (loop) {
        if (dir > 0 && track.scrollLeft >= maxScroll()) { track.scrollTo({ left: 0, behavior: 'smooth' }); return; }
        if (dir < 0 && track.scrollLeft <= 2) { track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' }); return; }
      }
      track.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { track.scrollTo({ left: k * step(), behavior: 'smooth' }); });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', update);
    update();

    if (auto > 0 && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      var paused = false;
      var start = function () {
        stop();
        timer = setInterval(function () { if (!paused && !document.hidden) go(1); }, auto);
      };
      var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
      box.addEventListener('mouseenter', function () { paused = true; });
      box.addEventListener('mouseleave', function () { paused = false; });
      box.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      box.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 4000); }, { passive: true });
      start();
    }
  }

  /* ---------- announcement bar ---------- */
  function initAnnouncement(el) {
    if (el.__sk) return;
    el.__sk = true;
    var msgs = qsa('.sk-ann__msg', el);
    if (msgs.length < 2) return;
    var i = 0;
    function show(n) {
      i = (n + msgs.length) % msgs.length;
      msgs.forEach(function (m, k) { m.classList.toggle('is-active', k === i); });
    }
    var p = el.querySelector('[data-ann-prev]');
    var n = el.querySelector('[data-ann-next]');
    if (p) p.addEventListener('click', function () { show(i - 1); });
    if (n) n.addEventListener('click', function () { show(i + 1); });
    var speed = parseInt(el.getAttribute('data-speed') || '4000', 10);
    var auto = el.getAttribute('data-autoplay') === 'true';
    if (auto && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      setInterval(function () { if (!document.hidden) show(i + 1); }, speed);
    }
  }

  /* ---------- reels (portrait videos) ---------- */
  var reelObserver = null;
  function initReels() {
    var vids = qsa('video[data-sk-reel]');
    if (!vids.length) return;
    if ('IntersectionObserver' in window) {
      if (!reelObserver) {
        reelObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var v = en.target;
            if (en.isIntersecting) {
              var pr = v.play();
              if (pr && pr.catch) pr.catch(function () {});
            } else {
              v.pause();
            }
          });
        }, { threshold: 0.5 });
      }
      vids.forEach(function (v) {
        if (!v.__sk) { v.__sk = true; reelObserver.observe(v); }
      });
    }
  }

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var openMenu = t.closest('[data-sk-menu-open]');
    var closeMenu = t.closest('[data-sk-menu-close]');
    var drawer = document.querySelector('[data-sk-drawer]');
    if (openMenu && drawer) {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('sk-lock');
      return;
    }
    if (closeMenu && drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('sk-lock');
      return;
    }

    var searchBtn = t.closest('[data-sk-search-toggle]');
    if (searchBtn) {
      var panel = document.querySelector('[data-sk-search-panel]');
      if (panel) {
        panel.classList.toggle('is-open');
        if (panel.classList.contains('is-open')) {
          var inp = panel.querySelector('input[type="search"]');
          if (inp) inp.focus();
        }
      }
      return;
    }

    var sound = t.closest('[data-sk-sound]');
    if (sound) {
      var box = sound.closest('[data-sk-reel-box]');
      var v = box && box.querySelector('video');
      if (!v) return;
      var turnOn = v.muted;
      qsa('video[data-sk-reel]').forEach(function (o) {
        o.muted = true;
        var ob = o.closest('[data-sk-reel-box]');
        if (ob) ob.classList.remove('is-sound');
      });
      if (turnOn) { v.muted = false; box.classList.add('is-sound'); }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var drawer = document.querySelector('[data-sk-drawer]');
    if (drawer && drawer.classList.contains('is-open')) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('sk-lock');
    }
    var panel = document.querySelector('[data-sk-search-panel]');
    if (panel) panel.classList.remove('is-open');
  });

  /* ---------- collection filters auto-submit ---------- */
  document.addEventListener('change', function (e) {
    var f = e.target && e.target.closest ? e.target.closest('form[data-sk-autosubmit]') : null;
    if (f) f.submit();
  });

  /* ---------- init ---------- */
  function initAll() {
    qsa('[data-sk-slider]').forEach(initSlider);
    qsa('[data-sk-announcement]').forEach(initAnnouncement);
    initReels();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
  document.addEventListener('shopify:section:load', initAll);
})();
